import { action, flow, makeObservable, observable } from 'mobx';
import { UserCourseApi } from '../apis';
import BaseStore from './BaseStore';

class UserCourseStore extends BaseStore {


    constructor(rootStore) {
        super();
        makeObservable(this, {
            getAverageScore: flow.bound,
            getCoursesAndAverageScore: flow.bound,
            getDataCSV: flow.bound,
            getStudentsByCourseId: flow.bound
        });
        this.rootStore = rootStore;
        this.api = new UserCourseApi();
    }
    *getAverageScore(payload) {
        const res = yield this.rootStore.apiStore.call(this.api, this.api.getAverageScore, payload);
        if (res?.ok) {
            return res.data;
        }
        return null;
    }
    *getCoursesAndAverageScore(payload) {
        const res = yield this.rootStore.apiStore.call(this.api, this.api.getCoursesAndAverageScore, payload);
        if (res?.ok) {
            return res.data;
        }
        return null;
    }
    *getDataCSV(payload) {
        const res = yield this.rootStore.apiStore.call(this.api, this.api.getDataCSV, payload);
        if (res?.ok) {
            return res.data;
        }
        return null;
    }
    *getStudentsByCourseId(id, payload) {
        const res = yield this.rootStore.apiStore.call(this.api, this.api.getStudentsByCourseId, { id, payload });
        if (res?.ok) {
            return res.data;
        }
        return null;
    }
}

export default UserCourseStore;
